import styled from 'styled-components';

export const TariffsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  height: 100%;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;
